import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Home from './pages/Home';
import Search from './pages/Search';
import Register from './pages/Register';
import Remove from './pages/Remove';

// Admin pages
import AdminOverview from './pages/admin/AdminOverview';
import ContentExplorer from './pages/admin/ContentExplorer';
import Domains from './pages/admin/Domains';
import CrawlQueue from './pages/admin/CrawlQueue';
import Removals from './pages/admin/Removals';
import Budget from './pages/admin/Budget';

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="search" element={<Search />} />
        <Route path="register" element={<Register />} />
        <Route path="remove" element={<Remove />} />
      </Route>

      {/* Admin routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminOverview />} />
        <Route path="content" element={<ContentExplorer />} />
        <Route path="domains" element={<Domains />} />
        <Route path="crawl-queue" element={<CrawlQueue />} />
        <Route path="removals" element={<Removals />} />
        <Route path="budget" element={<Budget />} />
      </Route>
    </Routes>
  );
}

export default App;
